import { SettingDetailModel } from "@/model/setting/settingDetailModel";
import { SettingModel } from "@/model/setting/settingModel";

export const maximumSettingSSOAmountBefore2026 = 750;
export const maximumSettingSSOAmount2026To2028 = 875;
export const maximumSettingSSOAmount2029To2031 = 1000;
export const maximumSettingSSOAmountSince2032 = 1150;

export function GetSettingSSOTemplate(settingsDetail: SettingDetailModel) {
  return {
    id: settingsDetail.id,
    registerSocialSecurity: settingsDetail.isRegisteredSSO ? 1 : 2,
    socialSecurityID: {
      value: settingsDetail.registeredSSONumber ? settingsDetail.registeredSSONumber : "",
      validateError: false,
    },
    branchType: settingsDetail.isHeadOffice ? 1 : 2,
    branchsocialSecurityID: {
      value: settingsDetail.branchNumber ? settingsDetail.branchNumber : "",
      validateError: false,
    },
    employersSocialSecurityRate: {
      value: settingsDetail.employerContritutionRate.FormatMoney() + "%",
      validateError: false,
    },
    employersSocialSecurity: {
      value: settingsDetail.employerContritutionMaxTotal.FormatMoney(),
      validateError: false,
    },
    employeesSocialSecurityRate: {
      value: settingsDetail.socialSecurityFundContributionRate.FormatMoney() + "%",
      validateError: false,
    },
    employeesSocialSecurity: {
      value: settingsDetail.socialSecurityFundContributionMaxTotal.FormatMoney(),
      validateError: false,
    },
    bankAccount: { id: settingsDetail.bankAccountId ? settingsDetail.bankAccountId : "" },
    paymentDefaultDay: { name: `${settingsDetail.paymentDefaultDay}`, value: settingsDetail.paymentDefaultDay },
    registerEmployeeWelfare: settingsDetail.employeeWelfareFundParticipation,
    employeeWelfareFundEmployeeRate: {
      value: settingsDetail.employeeWelfareFundEmployeeRate + "%",
      validateError: false,
    },
    employeeWelfareFundEmployerRate: {
      value: settingsDetail.employeeWelfareFundEmployerRate + "%",
      validateError: false,
    },
  };
}

export function ConvertToSettingModel(settingTemplate: any) {
  const settingModel: SettingModel = {
    id: settingTemplate.id,
    isRegisteredSSO: settingTemplate.registerSocialSecurity == 1 ? true : false,
    registeredSSONumber: settingTemplate.socialSecurityID.value,
    isHeadOffice: settingTemplate.branchType == 1 ? true : false,
    branchNumber: settingTemplate.branchsocialSecurityID.value,
    socialSecurityFundContributionRate: settingTemplate.employeesSocialSecurityRate.value.ToNumber(),
    employerContritutionMaxTotal: settingTemplate.employersSocialSecurity.value.ToNumber(),
    socialSecurityFundContributionMaxTotal: settingTemplate.employeesSocialSecurity.value.ToNumber(),
    employerContritutionRate: settingTemplate.employersSocialSecurityRate.value.ToNumber(),
    bankAccountId: settingTemplate.bankAccount.id ? settingTemplate.bankAccount.id : null,
    paymentDefaultDay: settingTemplate.paymentDefaultDay.value,
    employeeWelfareFundParticipation: settingTemplate.employeeWelfareFundParticipation,
    employeeWelfareFundEmployeeRate: settingTemplate.employeeWelfareFundEmployeeRate.value.ToNumber(),
    employeeWelfareFundEmployerRate: settingTemplate.employeeWelfareFundEmployerRate.value.ToNumber(),
  };
  return settingModel;
}

export function ValidateSettingTemplate(settingTemplate: any) {
  const socialSecurityIDValidateError = settingTemplate.socialSecurityID.validateError;
  const branchsocialSecurityIDValidateError = settingTemplate.branchsocialSecurityID.validateError;
  const employersSocialSecurityRateValidateError = settingTemplate.employersSocialSecurityRate.validateError;
  const employersSocialSecurityValidateError = settingTemplate.employersSocialSecurity.validateError;
  const employeesSocialSecurityRateValidateError = settingTemplate.employeesSocialSecurityRate.validateError;
  const employeesSocialSecurityValidateError = settingTemplate.employeesSocialSecurity.validateError;
  if (
    !socialSecurityIDValidateError &&
    !branchsocialSecurityIDValidateError &&
    !employersSocialSecurityRateValidateError &&
    !employersSocialSecurityValidateError &&
    !employeesSocialSecurityRateValidateError &&
    !employeesSocialSecurityValidateError
  ) {
    return true;
  } else {
    settingTemplate.socialSecurityID.validateError = socialSecurityIDValidateError;
    settingTemplate.branchsocialSecurityID.validateError = branchsocialSecurityIDValidateError;
    settingTemplate.employersSocialSecurityRate.validateError = employersSocialSecurityRateValidateError;
    settingTemplate.employersSocialSecurity.validateError = employersSocialSecurityValidateError;
    settingTemplate.employeesSocialSecurityRate.validateError = employeesSocialSecurityRateValidateError;
    settingTemplate.employeesSocialSecurity.validateError = employeesSocialSecurityValidateError;
    return false;
  }
}
